  <template>
    <div class="form">
      <!--     <v-dialog v-model="dialog" max-width="600px" persistent> -->
      
      <v-card>
        <v-card color="primary" flat>
          <v-card-title>

            <span class="headline white--text">{{ formTitle }}</span>
            <v-spacer></v-spacer>
            <v-btn class="ma-0 pa-0" color="white black--text " @click="close">
              Close
            </v-btn>
          </v-card-title>
        </v-card>

        <v-card-text>
          <v-card flat class="scroll">
            <v-form>
              <!-- {{getSchema.bn_name}} -->
               <h4></h4>
             <v-select
                      
                      item-text="name"
                      item-value="id"
                      v-model="getSchema.content_type_id"
                      :items="contentType"
                      outlined
                      label="Select Content Type"
             ></v-select>
              <div>
              <v-text-field
                name="Title"
                label="document_title"
                v-model="getSchema.document_title"
                outlined
              ></v-text-field>
            </div>
              <v-text-field
                name="Title"
                label="author_name"
                v-model="getSchema.author_name"
                outlined
              ></v-text-field>
               <v-text-field
                name="Title"
                label="subject"
                v-model="getSchema.subject"
                outlined
              ></v-text-field>
              <v-text-field
                name="Title"
                label="language"
                v-model="getSchema.language"
                outlined
              ></v-text-field>
              <v-text-field
                name="Title"
                label="tag"
                v-model="getSchema.tag"
                outlined
              ></v-text-field>
               <v-text-field
                name="Title"
                label="total_page"
                v-model="getSchema.total_page"
                outlined
              ></v-text-field>
              <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
              <!-- <v-btn @click="submitFile()">Submit</v-btn> -->
              
              
            </v-form>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-layout justify-space-between>
            <v-btn color="primary  white--text" @click.stop.prevent="validationForm()"
              >{{buttonTitle}}</v-btn
            >
            <span></span>
            <v-btn color="primary  white--text" @click="clear">Reset</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
      <!--     </v-dialog> -->
    </div>
  </template>

  <script>
  export default {
    // $_veeValidate: {
    //   validator: "new",
    // },
    components: {},
    props: ["dialogStatus", "editedData","indexEdited"],
    data: () => ({
      contentType:[
         {
         	id:1,
         	name:"pdf"
         },
         {
         	id:2,
         	name:"audio"
         },
         {
         	id:3,
         	name:"video"
         },
      ],
      file: '',
      loading: false,
      dialog: false,

    
    }),
    created() {},
    mounted() {
      // this.$validator.localize("en", this.dictionary);
    },
    watch: {
      dialogStatus(val) {
      
        this.dialog = val;
        this.$store.commit("SET_E_CONTENT_SCHEMA", this.editedData);
       
      },
      dialog(val) {
        if (!val) this.close();
      },
    },
    computed: {
      getSchema() {
        return this.$store.getters.getEContentSchema;
      },
      
      buttonTitle() {
        return this.indexEdited === -1 ? "Save" : "Edit";
      },
      formTitle() {
        return this.indexEdited === -1
          ? "Create New E-Content"
          : "Edit E-Content ";
      },
    },
    methods: {
    	  handleFileUpload(){
          this.file = this.$refs.file.files[0];
        },
            save(){
              let self = this;
              let formData = new FormData();
              formData.append('upload_content', this.file);
              formData.append('content_type_id', this.getSchema.content_type_id);
              formData.append('document_title', this.getSchema.document_title);
              formData.append('author_name', this.getSchema.author_name);
              formData.append('subject', this.getSchema.subject);
              formData.append('tag', this.getSchema.tag);
              formData.append('language', this.getSchema.language);
              formData.append('total_page', this.getSchema.total_page);
              
             //  console.log("formData",formData);
              
               this.$store
          .dispatch("saveEContentData", formData)
          .then(function (data) {
           //  console.log("submit xa")
           
            try {
              self.close();
              self.$store.dispatch("callEContentData");
             
            } catch (ex) {
             //  console.log(ex);
            }
          })
          .catch(function () {
           //  console.log();
            
          });

        
        },
      // save() {
      //   let self = this;
      //   this.getSchema.upload_content = this.file;
      //   let item = this.getSchema;
      //   this.$store
      //     .dispatch("saveEContentData", item)
      //     .then(function (data) {
           
           
      //       try {
      //         self.close();
      //         self.$store.dispatch("callEContentData");
      //         //self.$store.dispatch("fetchCenLsDistToRegData"




              
      //       } catch (ex) {
      //        //  console.log(ex);
      //       }
      //     })
      //     .catch(function () {
      //      //  console.log();
      //       //self.$store.dispatch("fetchCenLsDistToRegData");
      //     });
      // },
      edit() {
      let self = this;
      let item = this.getSchema;

     
    
             let formData = new FormData();
              formData.append('upload_content', this.file);
              formData.append('content_type_id', this.getSchema.content_type_id);
              formData.append('document_title', this.getSchema.document_title);
              formData.append('author_name', this.getSchema.author_name);
              formData.append('subject', this.getSchema.subject);
              formData.append('tag', this.getSchema.tag);
              formData.append('language', this.getSchema.language);
              formData.append('total_page', this.getSchema.total_page);
              formData.append('status', this.getSchema.status);
              formData.append('content_url', "dddd.ddd.com");
              formData.append('_method', 'PUT');
          // fd.append('_method', 'PUT');

          this.$store
            .dispatch("updateEContent", { formData: formData, id: item.id })
            .then(function(data) {
              try {
                self.close();
                 self.$store.dispatch("callEContentData");
                
                
              } catch (ex) {
               //  console.log(ex);
              }
            })
            .catch(function(error) {
             //  console.log(error);
              
            });
        
  
    },
      // edit() {
      //   let self = this;
      //   let item = this.getSchema;
      //  //  console.log("edit schema print",item);
      //   let formData = new FormData();
      //         formData.append('upload_content', this.file);
      //         formData.append('content_type_id', this.getSchema.content_type_id);
      //         formData.append('document_title', this.getSchema.document_title);
      //         formData.append('author_name', this.getSchema.author_name);
      //         formData.append('subject', this.getSchema.subject);
      //         formData.append('tag', this.getSchema.tag);
      //         formData.append('language', this.getSchema.language);
      //         formData.append('total_page', this.getSchema.total_page);
      //   this.$store
      //     .dispatch("editEContentData", formData)
      //     .then(function(data) {
            
      //       self.close();
            
      //       self.$store.dispatch("callEContentData");
      //     })
      //     .catch(function(error) {
      //      //  console.log(error);
      //       //self.$store.dispatch("fetchCenLsDistToRegData");
      //     });
      // },
     
      close() {
        this.$emit("update:dialogStatus", false);
        setTimeout(() => {
          this.$emit("update:indexEdited", -1);
        }, 300);
        this.clear();
      },
   
      validationForm() {
        // this.$validator.validateAll().then((isValid) => {
          // if (isValid) {
            return this.indexEdited === -1 ? this.save() : this.edit();
          // }
        // });
      },
      clear() {
        this.getSchema.content_type_id = "";
        this.getSchema.document_title = "";
        this.getSchema.author_name = "";
        this.getSchema.subject = "";
        this.getSchema.tag = "";
        this.getSchema.language = "";
        this.getSchema.total_page = "";
        
      },
    },
  };
  </script>

 </script>

<style scoped>
.scroll {
  overflow-y: auto;
}
@media (min-width: 576px) {
  .form-card-size {
    max-width: 5px;
    /* width: 500px; */
  }
}
@media (min-width: 768px) {
  .form-card-size {
    max-width: 60px;
  }
}

@media (min-width: 992px) {
  .form-card-size {
    max-width: 120px;
  }
}

@media (min-width: 1200px) {
  .form-card-size {
    max-width: 300px;
  }
}
</style>
